import { useMemo } from "react";

import {
  resolveAiFeatureSettings,
  type AiFeatureSettings,
  type ResolvedAiFeatureSettings,
} from "@hightouch/lib/entitlements/ai-feature-settings";

import { useUser } from "src/contexts/user-context";

export { resolveAiFeatureSettings };
export type { AiFeatureSettings, ResolvedAiFeatureSettings };

/**
 * Resolved org-level AI feature settings for the current workspace's org.
 */
export const useAiFeatureSettings = (): ResolvedAiFeatureSettings => {
  const { workspace } = useUser();
  const settings = workspace?.organization?.ai_feature_settings as
    | AiFeatureSettings
    | null
    | undefined;

  return useMemo(() => resolveAiFeatureSettings(settings), [settings]);
};
